<h1>MyCE Request Help</h1>

<div class="col-sm-12 col-md-6 col-lg-4">
    <div class="list-group">
        <a href="https://corteva-research.atlassian.net/wiki/spaces/OSKB/pages/4275802574/MyCE+Request+User+Guide" target="_blank" class="list-group-item">User Guide and Frequently Asked Questions</a>
        <a href="https://corteva-research.atlassian.net/servicedesk/customer/portal/22" target="_blank" class="list-group-item">Report a System Issue</a>
    </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/help/help-page/help-page.component.html